(function() { window.GUID_298c9db2_2afc_494b_9483_53cedfbc8ffe = { getGuid: function() { return "298c9db2-2afc-494b-9483-53cedfbc8ffe"; } }; })();
var Newsfeed;
(function (Newsfeed) {
    let Filter;
    (function (Filter) {
        Filter[Filter["All"] = 0] = "All";
        Filter[Filter["FromMe"] = 1] = "FromMe";
        Filter[Filter["ToMe"] = 2] = "ToMe";
    })(Filter = Newsfeed.Filter || (Newsfeed.Filter = {}));
    new Newsfeed.NewsfeedPosts();
})(Newsfeed || (Newsfeed = {}));

//# sourceMappingURL=newsfeed.js.map
